import _ from 'lodash'

import type { FilterSpec, Filters } from 'types/filter'
import type { MultiSelectProp } from 'components/common/MultiSelect'
import type { Options, ToggleFn } from 'types/common'

import { PAGE_FILTER_PLACEHOLDER } from 'constants/common'
import { FilterCustomOption } from './FilterDropdown/components'

export const getFilterKeysByPredicate = (
  filtersSpecs: FilterSpec[],
  predicate: Record<string, unknown>
): string[] => _(filtersSpecs).filter(predicate).map('key').value()

export const getValidFilters = (filters: Filters): Filters =>
  _.omitBy(filters, v => _.isNil(v) || (_.isArray(v) && _.isEmpty(v)))

export const getCommonSelectProps = ({
  value,
  isMulti,
  useOptionValueOnly,
  onChange,
  toggleOpen,
  formatOptionLabel,
}: MultiSelectProp & { toggleOpen: ToggleFn }): Partial<MultiSelectProp> => ({
  value: isMulti ? value : _.first(value),
  isMulti,
  useOptionValueOnly,
  placeholder: 'Search...',
  autoFocus: true,
  dropdownOnly: true,
  backspaceRemovesValue: false,
  controlShouldRenderValue: false,
  hideSelectedOptions: false,
  isClearable: false,
  tabSelectsValue: false,
  onChange: option => {
    onChange(option)
    if (!isMulti) {
      toggleOpen()
    }
  },
  components: { Option: FilterCustomOption(formatOptionLabel) },
})

export const getFilterDropdownBadgeLabel = (
  selectedOptions: Options
): string => {
  if (_.isEmpty(selectedOptions)) {
    return PAGE_FILTER_PLACEHOLDER
  }

  const firstOptionLabel = selectedOptions[0]?.label ?? ''
  const additionalCount =
    selectedOptions.length > 1 ? ` + ${selectedOptions.length - 1}` : ''
  return `${firstOptionLabel}${additionalCount}`
}
